
























































import {Component, Prop, Vue} from "vue-property-decorator";
import PxTextEntryBox from "@/views/components/input/formFields/PxTextEntryBox.vue";
import {createNewProject} from "@/lib/createNew/project";
import {projectStore, userStore} from "@/store/store";
import router from "@/router";
import PxDropdown from "@/views/components/input/formFields/PxDropdown.vue";
import {INewProjectMetadata, IProjectMetadata} from "@/interfaces/report";
import PxTextArea from "@/views/components/input/formFields/PxTextArea.vue";
import {states} from "@/lib/data/states";

@Component({
  name: "NewProject",
  components: {PxTextArea, PxDropdown, PxTextEntryBox},
})
export default class NewProject extends Vue {
  @Prop() id!: number | null | undefined;

  project: INewProjectMetadata | IProjectMetadata | null = null;

  created() {
    if (this.id) {
      projectStore.getProjectMetadata(this.id).then((P) => this.project = P);
    } else {
      this.project = createNewProject(userStore.user);
    }
  }

  success = false;

  get errors() {
    return projectStore.httpErrors;
  }

  stateOptions = states;

  saveProject() {
    if (this.project !== null && this.project.id === null) {
      console.log("Creating", this.project);
      projectStore.createProject(this.project).then(
          (project) => {
            console.log(project);
            if (project) {
              router.push(`/projects/${project.id}`);
            }
          },
      );
    } else {
      projectStore.updateProject(<IProjectMetadata>this.project).then(
          project => { console.log(project);
            if (project) {
              router.push(`/projects/${project.id}`);
            }
          },
      );
    }
  }
}

